import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import EditModulesModal from './Edit';
import LevelSystemModal from './LevelSystem';
import { MODAL_EDIT, MODAL_EDIT_GOOGLE_AUTH } from './constants/modals';

const modalsComponentsList = [
  {
    modalKey: MODAL_EDIT,
    Component: EditModulesModal,
    options: {
      bsSize: 'small',
      className: 'modal-md-custom',
    },
  },
  {
    modalKey: MODAL_EDIT_GOOGLE_AUTH,
    Component: EditModulesModal,
    options: {
      bsSize: 'large',
      className: 'settings-modules__modal-google-user',
    },
  },
  {
    modalKey: 'module_user_level_system_modal',
    Component: LevelSystemModal,
    options: {
      bsSize: 'large',
      className: 'settings-modules__modal-level-system',
    },
  },
]

const ModalsManager = ({ access, modalData, onHide, onSubmit }) => {
  const onHideModal = (type) => {
    onHide(type);
  }

  return (
    <>
      {modalsComponentsList.length
        ? modalsComponentsList.map((modal) => {
          const { Component, options } = modal;
          const showModal = modal?.modalKey === modalData.openModalKey;
          return (
            <Modal
              key={`modal-${modal.modalKey}`}
              show={showModal}
              backdrop="static"
              {...options}
            >
              <Component
                onHide={onHideModal}
                onSubmit={onSubmit}
                data={modalData.data}
                access={access}
              />
            </Modal>
          )
        }) : null}
    </>
  );
}

ModalsManager.propTypes = {
  open: PropTypes.string,
  openConfirmModal: PropTypes.bool,
  item: PropTypes.object,
  access: PropTypes.object,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  modalData: PropTypes.object,
  onDeactivate: PropTypes.func,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ModalsManager;
